/**
 * La taille du champion des félicitations, tirée de la place que la page lui laisse. Pur.
 *
 * Le pied (« Activité suivante », « Retour à mes activités ») est fixe ; au-dessus, la célébration se
 * lit d'un coup d'œil, sans défiler : le champion, son mot, et les tuiles de ce que l'activité a
 * rapporté. Sur un petit téléphone, dans le volet du live, ou avec la bulle tandem gardée au pied, la
 * place manque : c'est le champion qui rapetisse, jamais les tuiles qui passent sous le pied. Sous
 * `CONGRATS_FIGURE_MIN`, il ne rapetisse plus, et la célébration défile.
 */

/** La taille pleine du champion, celle d'un téléphone où tout tient. */
export const CONGRATS_FIGURE_HEIGHT = 240
/** En dessous, le champion ne se reconnaît plus : la célébration défile plutôt. */
export const CONGRATS_FIGURE_MIN = 120

/**
 * `available` : la hauteur de la zone au-dessus du pied (ses marges retirées) ; `rest` : celle de
 * ce qui suit le champion (son mot, les tuiles) et l'écart qui l'en sépare. Rien de mesuré encore
 * (0) : la taille pleine.
 */
export function congratsFigureHeight(available: number, rest: number): number {
    if (available <= 0 || rest <= 0) return CONGRATS_FIGURE_HEIGHT
    const room = Math.floor(available - rest)
    return Math.max(CONGRATS_FIGURE_MIN, Math.min(CONGRATS_FIGURE_HEIGHT, room))
}
